import React,{useEffect, useState} from 'react'
import termsTemplateServices from '../termsTemplateServices';
import { Tooltip } from '@mui/material';


function SelectTermsTemplate({callBack}) {

    const [termsTemplateList,setTermsTemplateList] = useState(null)

    const getTermsTemplateList = () =>{
        termsTemplateServices.getList().then(res=>{
            setTermsTemplateList(res.data);
        }).catch(error=>{

        })
    }

    useEffect(()=>{
        getTermsTemplateList();
    },[])

    return (
        <>
            {termsTemplateList?.map(template=> 
                <Tooltip title={<span dangerouslySetInnerHTML={{ __html: template.details }} />}>
                    <btn className='btn btn-outline-primary m-2' onClick={()=>callBack(template.details)} >{template.title}</btn>
                </Tooltip>
            )}
        </>
    )
}

export default SelectTermsTemplate